import HTTP_GESCOM from '@/api/HTTP_GESCOM';
import transformer from '@/services/client/tiersServerTableDataTransformer';
import gestionErreur from '@/services/general/gestionErreur';
import {
  dataListMapper, dataDetailMapper, dataPostCreateMapper,
  queryPanneauxSousContratMapper,
} from '@/mapping/client.mapping';
import { WITHOUT_LOGO } from '@/configuration/clientConf';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';

const URL_BASE = 'commun/Tiers/';
const PANNEAUX_SOUS_CONTRAT_URL = 'gescom/LigneCommande/PGetAllParPdvAsync';

export async function browseClients(whithLogo, query) {
  const transformedQuery = transformer(query);
  try {
    const { result } = (await HTTP_GESCOM.post(URL_BASE + 'PGetAllAsync', transformedQuery)).data;
    const res = { ...result, data: result.items.map(dataListMapper) };
    if (whithLogo !== WITHOUT_LOGO) await getPiecesJointeLogoByIds(res.data, 'id', 'tiersParentId');
    return res;
  } catch (e) {
    gestionErreur('Erreur lors de la récupération des clients', e);
  }
}

export async function addClients(data) {
  const response = await HTTP_GESCOM.post(URL_BASE + 'CreateAsync', dataPostCreateMapper(data));
  return { data: dataDetailMapper(response.data.result) };
}

export async function updateClient(data) {
  const response = await HTTP_GESCOM.put(URL_BASE + 'UpdateAsync', dataPostCreateMapper(data));
  return { data: dataDetailMapper(response.data.result) };
}

export async function addManyClients(data) {
  try {
    const payload = data.map(dataPostCreateMapper);
    const response = await HTTP_GESCOM.post(URL_BASE + 'CreateAllAsync', payload);
    return response;
  } catch (e) {
    gestionErreur('Erreur lors de la création des clients', e);
  }
}

export async function browseDetailClient(id) {
  try {
    const response = await HTTP_GESCOM.get(URL_BASE + 'GetAsync', { params: { id } });
    return { data: dataDetailMapper(response.data.result) };
  } catch (e) {
    gestionErreur('Erreur lors de la récupération du client', e);
  }
}

export async function getClientsInferieur(id) {
  try {
    const response = await HTTP_GESCOM.get(URL_BASE + 'GetWithLiensInferieursAsync', { params: { id } });
    return { data: response.data.result.tiersEnfants.map(dataListMapper) };
  } catch (e) {
    gestionErreur('Erreur lors de la récupération des clients enfants', e);
  }
}

export async function getAllProduitsSousContrat(payload) {
  const query = queryPanneauxSousContratMapper(payload);
  try {
    const response = await HTTP_GESCOM.post(PANNEAUX_SOUS_CONTRAT_URL, query);
    return response;
  } catch (e) {
    gestionErreur('Erreur lors de la récupération des produits sous contrat du client');
  }
}

export async function ArchiverClient(id) {
  try {
    return await HTTP_GESCOM.post(URL_BASE + 'ArchiverAllAsync', { ids : [id], archiver : true });
  } catch (e) {
    gestionErreur('Erreur lors de l\'archivage du client', id);
  }
}
